import React from "react";
import { Link, Outlet } from "react-router-dom";
import FooterSocial from "../FooterSocial/FooterSocial";
import FooterLinks from "../FooterLinks/FooterLinks";

export default function Footer() {
  return (
    <>
      <Outlet />
      <footer
        className={
          "bg-black text-white flex flex-col  md:justify-between items-start gap-2 md:gap-0 min-h-28 border-t-2 border-white"
        }
      >
        <div className="flex flex-wrap w-full sm:justify-center md:justify-between p-4 gap-4">
          <div className="md:pt-4">
            &copy; 2024 <Link to={"/admin-panel/"}>WHITEBULL</Link>. Wszystkie
            prawa zastrzeżone.
          </div>
          <div className="py-4">{/* <FooterLinks /> */}</div>
        </div>

        <div className="px-4 pb-4 border-t-[1px] border-white/35 w-full text-white/65">
          <FooterSocial />
        </div>
      </footer>
    </>
  );
}
